<div class="pb-5 fade relative">
  <form  [formGroup]="phoneform">
    <div class="inline-text-field-container even-cols flex-row gap-20">
      <div class="ds-text-field">
        <input class="ds-text-field__input" id="areacode" type="text"  autocomplete="off" value="selectedphone?.areaCode" [(ngModel)]="selectedphone.areaCode"  formControlName="areacode" maxlength="3">
        <label for="address" class="ds-floating-label ">*Area Code (e.g.345)</label>
        <div class="field-line-ripple blue"></div>
        @if (phoneform.get('areacode').invalid && phoneform.get('areacode').errors && (phoneform.get('areacode').dirty || phoneform.get('areacode').touched)) {
          <div>
            @if (phoneform.get('areacode').hasError('required')) {
              <span id="areacode-errmsg" class="error errmsg">Enter a Areacode</span>
            }
            @if (phoneform.get('areacode').hasError('pattern')) {
              <span id="areacodepattern-errmsg" class="error errmsg">Enter a valid Areacode</span>
            }
          </div>
        }
      </div>
      <div class="ds-text-field">
        <input class="ds-text-field__input" id="phonenumber" type="text" autocomplete="off" value="selectedphone?.phoneNumber" [(ngModel)]="selectedphone.phoneNumber" (input)="addHyphen($event)" formControlName="phonenumber" maxlength="7" minlength="7">
        <label for="city" class="ds-floating-label ">*Number (e.g. 9999999)</label>
        <div class="field-line-ripple blue"></div>
        @if (phoneform.get('phonenumber').invalid && phoneform.get('phonenumber').errors && (phoneform.get('phonenumber').dirty || phoneform.get('phonenumber').touched)) {
          <div>
            @if (phoneform.get('phonenumber').hasError('required')) {
              <span id="phonenumber-errmsg" class="error errmsg">Enter a Phonenumber</span>
            }
            @if (phoneform.get('phonenumber').hasError('pattern')) {
              <span id="phonepattern-errmsg" class="error errmsg">Enter a valid Phonenumber</span>
            }
          </div>
        }
      </div>
      <div class="select-entire mt-20 mobile">
        <input type="checkbox" id="primary-phone" name="primary-phone" value="primary-phone" [checked]="selectedphone?.primaryFlag==true" (change)="setPrimaryfalg($event)">
        <label for="primary-phone"> Primary Phone</label>
      </div>
    </div>
    <div class="container flex gap-20 justify-end">
      <button title="Cancel" (click)="cancel()" id=""
        class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
        <div class="btn-txt font-red bold">Cancel</div>
      </button>
      <button title="Update Phone" (click)="update()" class="rounded-full hover-blue-800 black" [disabled]="!phoneform.valid">
        <div class="btn-txt font-white">Update Phone</div>
      </button>
    </div>
  </form>
</div>
